import { sort } from "@common/lib/array";
import { first, last } from "lodash";
import { type PackagePricing } from "./types";

export type MinMax = {
  min: number;
  max: number;
};
export const getTiersMinMax = (tiers: PackagePricing.Api.TierCount[], max: number): MinMax => {
  const sorted = sort(tiers, { key: "startValue" });
  return {
    min: first(sorted)?.startValue ?? 1,
    max: last(sorted)?.endValue ?? max
  };
};
